"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSubscribeFunction = exports.createPublishFunction = void 0;
const eventBusManager_1 = require("../eventBusManager");
const createPublishFunction = (channelKey, EventClass) => {
    return (params) => {
        const event = new EventClass(params);
        const globalEvent = (0, eventBusManager_1.getGlobalEventBus)();
        if (!globalEvent) {
            throw new Error(`Error publishing ${channelKey}: should initialize or set a globalEventBus`);
        }
        return globalEvent?.publish(channelKey, event);
    };
};
exports.createPublishFunction = createPublishFunction;
const createSubscribeFunction = (channelKey) => {
    return (callback) => {
        const globalEvent = (0, eventBusManager_1.getGlobalEventBus)();
        if (!globalEvent) {
            throw new Error(`Error subscribing ${channelKey}: should initialize or set a globalEventBus`);
        }
        return globalEvent.subscribe(channelKey, event => callback(event.getData()));
    };
};
exports.createSubscribeFunction = createSubscribeFunction;
//# sourceMappingURL=factory.js.map